import { Component, OnInit } from '@angular/core';
import { Any } from 'src/app/shared/models/signature.model';
import { VerifySignatureBehaviorService } from 'src/app/services/behavior/verify-signature-behavior.service';
import { SignatureService } from 'src/app/services/signature-service/signature.service';

@Component({
  selector: 'app-verify-signature',
  templateUrl: './verify-signature.component.html',
  styleUrls: ['./verify-signature.component.scss']
})
export class VerifySignatureComponent implements OnInit {

  title!:string;
  subscribers:number = 0;
  doc!:string;
  docSigned!:string;

  SHA!:string;
  typeSHA!:string;

  cardBorder:string = 'border-light';
  tileColor:string = '';
  valid:boolean = false;
  icon:boolean = false;

  constructor(
    private readonly verifySignature: VerifySignatureBehaviorService,
    private readonly signatureService: SignatureService
  ) { }

  downloadFile(uid:string, type:string){
    this.signatureService.download(uid, type).subscribe((res:Any) => {
      const link = document.createElement("a");
      link.href = `data:application/pdf;base64,${res.dto}`;
      var birthday = new Date();
      link.download = birthday.getTime() + '_' + 'signature.pdf'
      link.click();
    })
  }

  verifyDigitalSignature(){
    this.signatureService.verifyDigitalSignature(this.doc, this.SHA, this.typeSHA).subscribe(res => {
      if(res.dto) {
        this.cardBorder = 'border-success'
        this.tileColor = 'text-success'
        this.valid = true;
        this.icon = true;
      } else {
        this.cardBorder = 'border-danger'
        this.tileColor = 'text-danger'
        this.valid = false;
        this.icon = true;
      }
    })
  }

  onItemChange(){
    this.SHA = this.SHA.replace(/\s/g, '')
  }

  ngOnInit(): void {
    this.verifySignature.data.subscribe(data => {
      this.subscribers = 0;
      this.title = data.file.name
      data.subscribers.forEach(res=> {
        if(res.signed == true){
          this.subscribers++
        } 
      })
      this.doc = data.uid
      this.docSigned = data.uidSigned
      this.cardBorder = 'border-light';
      this.tileColor = '';
      this.SHA = '';this.typeSHA = '';
      this.valid = false;
      this.icon = false;
    })
  }

}
